<template>
  <div>
    <user-upcoming-visits></user-upcoming-visits>
    <user-upcoming-labs></user-upcoming-labs>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UserUpcomingVisits from "@/components/UserUpcomingVisits.vue";
import UserUpcomingLabs from "@/components/UserUpcomingLabs.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    UserUpcomingVisits,
    UserUpcomingLabs,
  },
});
</script>
